import { defineFieldFormInterface } from "~/entities/field";
import ListM2MAliasType from "../AliasType/ListM2MAliasType.vue";

export default defineFieldFormInterface({
  type: "alias",
  interface: "list-m2m",
  component: ListM2MAliasType,
});
